import React from 'react';
import styled from 'styled-components';
import {
  propTypes, defaultProps, isContactable,
} from '../prop-types';
import ContactForm from './contact-form';
import ContactButton from './contact-button';
import AnimatedProfileFollowButton from '../../shared/animated-profile-follow-button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &&&& > button[name="profile-follow-button"] {
    width: 100%;

    > .icon-box > .icon-lw-user-check {
      left: 0px;
    }
  }
`;

export default function Actions(props) {
  const { profile } = props;

  if (!profile.canPostWires) {
    return null;
  }

  const {
    isOfCurrentUser, isProfileFollowedByCurrentUser, onUnfollow, followEventName, unfollowEventName,
  } = props;
  const contactable = isContactable(props);
  const showFollowButton = !isOfCurrentUser && !isProfileFollowedByCurrentUser;

  const followButtonProps = {
    isProfileFollowedByCurrentUser,
    onUnfollow,
    profileId: profile.id,
    followEventName,
    unfollowEventName,
    exp: 'eow_streamlined_micro_profile',
  };

  return (
    <>
      <Container className="micro-profile-actions">
        {!!showFollowButton && <AnimatedProfileFollowButton {...followButtonProps} />}
        {!!contactable && <ContactButton name="profile-contact-button" />}
      </Container>
      {!!contactable && <ContactForm {...props} />}
    </>
  );
}

Actions.propTypes = propTypes;
Actions.defaultProps = defaultProps;
